import { render, staticRenderFns } from "./IngestorConnectionError.vue?vue&type=template&id=e4f96838"
import script from "./IngestorConnectionError.vue?vue&type=script&lang=js"
export * from "./IngestorConnectionError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports